import cn from "classnames";
import styles from "./styles.module.scss";

type Props = {
  children?: any;
  showContent?: boolean;
  className?: string;
};

const SkeletonBlock = ({
  children,
  showContent = false,
  className = "",
}: Props) => (
  <div className={cn(!showContent && styles.skeleton, className)}>
    {children}
  </div>
);

export default SkeletonBlock;
